import { Routes } from '@angular/router'
import { ROUTE_TITLES } from '../core/branding/route-titles'
import { agencyHostLanguageGuard, confirmedPlatformMatch } from '../core/branding/host-routing'

// FR-051 U7: on an agency host these pre-login pages speak the host brand's
// language (agencyHostLanguageGuard → FR-050's brandLanguageGuard); on the
// platform host the guard is a no-op. `/register` is not reachable on an agency
// host (app.routes.ts host gates).
export const authRoutes: Routes = [
  {
    path: 'login',
    title: ROUTE_TITLES.login,
    canActivate: [agencyHostLanguageGuard],
    loadComponent: () => import('../features/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'forgot-password',
    title: ROUTE_TITLES.forgotPassword,
    canActivate: [agencyHostLanguageGuard],
    loadComponent: () =>
      import('../features/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
  },
  {
    path: 'reset-password',
    title: ROUTE_TITLES.resetPassword,
    canActivate: [agencyHostLanguageGuard],
    loadComponent: () =>
      import('../features/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
  },
  {
    // REQ-9 (FR-006 §9) — public, token-authenticated invitation accept. The
    // link is emailed via the outbox; new users set their own password, existing
    // users just accept (password untouched). Mirrors reset-password (no guard).
    path: 'accept-invitation',
    title: ROUTE_TITLES.acceptInvitation,
    canActivate: [agencyHostLanguageGuard],
    loadComponent: () =>
      import('../features/accept-invitation/accept-invitation.page').then(
        (m) => m.AcceptInvitationPage
      ),
  },
  {
    path: '403',
    title: ROUTE_TITLES.forbidden,
    canActivate: [agencyHostLanguageGuard],
    loadComponent: () =>
      import('../features/forbidden/forbidden.page').then((m) => m.ForbiddenPage),
  },
  {
    path: 'register',
    // FR-051 U7 fix F-A: self-registration only on a host CONFIRMED as the platform's.
    canMatch: [confirmedPlatformMatch],
    title: ROUTE_TITLES.register,
    loadComponent: () => import('../features/register/register.page').then((m) => m.RegisterPage),
  },
]
